import * as React from 'react';

import { HONEST_LEVEl_ICON } from './helpers/constants';
import * as style from './style.css';

interface IAgentHonestProps {
  level: number;
}

export const AgentHonest: React.FC<IAgentHonestProps> = ({ level }) => {
  const icon = HONEST_LEVEl_ICON[level];

  return (
    <div className={style['agent-honest']}>
      <img src={icon} />
    </div>
  );
};
